import useAuth from "context/useAuth";

import HeaderLoggedOut from "./HeaderLoggedOut";
import HeaderLoggedIn from "./HeaderLoggedIn";
import HeaderMobileButton from "./HeaderMobileButton";

function HeaderCombined() {
  const { user } = useAuth();

  return (
    <>
      {user ? <HeaderLoggedIn /> : <HeaderLoggedOut />}
      <HeaderMobileButton /> {/* what even is this... */}
    </>
  );
}

export default HeaderCombined;
